import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@heroui/react";

export const Route = createFileRoute("/user/account/disable")({
  component: Page,
});


export default function Page() {
    return (
        <div className={"m-8 flex flex-col gap-4"}>
            <section className={"flex flex-col items-center gap-4"}>
                <h1 className={"text-3xl"}>账号注销</h1>
                <div className={"text-gray-500"}>您正在进行账号注销操作，在您确定注销前，您需要仔细阅读并检查以下内容，以免造成损失：</div>
            </section>
            <section className={"flex flex-col gap-6"}>
                <div>
                    <div className={"font-bold mb-1 text-lg"}>1. 正在进行中的订单</div>
                    <div className={"text-gray-500"}>确保您没有正在进行中的订单，如果注销账号时有确认中的订单，系统将视为放弃委托，金额将归对方另一方所有。</div>
                </div>
                <div>
                    <div className={"font-bold mb-1 text-lg"}>2. 支付财产结清</div>
                    <div className={"text-gray-500"}>确保您帐户内的余额钱包、收入钱包中的金额均已提现，如注销时仍有余额，系统将视为放弃余额。</div>
                </div>
                <div>
                    <div className={"font-bold mb-1 text-lg"}>3. 无任何进行中的纠纷案件</div>
                    <div className={"text-gray-500"}>进行注销前，需要确保您帐户不包含正在进行、悬而未决的纠纷或投诉案件。</div>
                </div>
                <div>
                    <div className={"font-bold mb-1 text-lg"}>4. 无任何在售的商品或委托</div>
                    <div className={"text-gray-500"}>进行注销前，您需要下架所有在架的商品和关闭任何开启的委托。</div>
                </div>
                <div>
                    <div className={"font-bold mb-1 text-lg"}>5. 下架不希望展示的内容</div>
                    <div className={"text-gray-500"}>您注销后，您的公开内容将依然存在（但用户会显示已注销），因此，避免带来不必要的隐患，您需要主动下架任何不希望留存在平台内对外展示的公开内容（如作品集）。</div>
                </div>
                <div>
                    <div className={"font-bold mb-1 text-lg"}>6. 您的实名和登录信息将依然有效</div>
                    <div className={"text-gray-500"}>应监管要求，您注销后，您的部分必要信息将依然有效，您将无法再次使用相同的证件进行实名认证。如后续发现账号有发布的违反法律法规的违规信息，平台依然会保留追诉的权利。</div>
                </div>
            </section>
            <section className={"flex flex-col gap-4"}>
                <div className={"text-gray-500"}>请您仔细阅读并确认以上内容，如有任何疑问，请联系客服。</div>
                <div className={"text-gray-500"}>如果您已经确认了以上内容，您可以点击下方按钮进行账号开始注销流程。</div>
            </section>
            <section className={"flex flex-col gap-4"}>
                <Button>确认注销</Button>
            </section>
        </div>
    )
}
